import z from "zod";
import { options } from "../constants.schema";

const validate_url = z
  .string()
  .optional()
  .refine((val) => !val || /^https?:\/\/.+$/.test(val), {
    message: "Must be a valid URL",
  });

export const generalInformationJobberSchema = z.object({
  first_name: z.string().nonempty("The first name is required."),
  last_names: z.string().nonempty("The last name is required."),
  location_country: z.object(options).refine((val) => val.id !== "", {
    message: "The location country is required.",
  }),
  location_state: z.object(options).refine((val) => val.id !== "", {
    message: "The location state is required.",
  }),
  birth_date: z
    .string()
    .min(1, "Date of birth is required.")
    .optional() as z.ZodType<string | null>,
  phone_number: z
    .object({
      country_id: z.string().nonempty(),
      phone_number: z.string().min(4),
    })
    .refine((val) => val.country_id && val.phone_number, {
      message: "The phone number is required",
    }),
  monthly_expect_full_time: z.preprocess(
    (val) =>
      val === "" ? undefined : typeof val === "string" ? parseFloat(val) : val,
    z.number().min(1, "Full-time monthly expectation is required")
  ) as z.ZodType<number>,
  monthly_expect_part_time: z.preprocess(
    (val) =>
      val === "" ? undefined : typeof val === "string" ? parseFloat(val) : val,
    z.number().min(1, "Part-time monthly expectation is required")
  ) as z.ZodType<number>,
  rate_per_hour: z.preprocess(
    (val) =>
      val === "" ? undefined : typeof val === "string" ? parseFloat(val) : val,
    z.number()
  ) as z.ZodType<number>,
  linkedin_url: validate_url,
  behance_url: validate_url,
  website_url: validate_url,
  github_url: validate_url,
  profile_picture: z
    .union([
      z.instanceof(File), // si es File válido
      z.string(), // si es string (URL)
      z.null(), // si es null
    ])
    .optional(),
  cover_letter: z.string().optional(),
  open_to_work: z.object(options).optional(),
  work_modes: z
    .array(z.object(options))
    .min(1, "You must select at least one option"),
});

export type GeneralInformationJobberType = z.infer<
  typeof generalInformationJobberSchema
>;
